export const SCAN_OPTIONS_STORAGE_KEY = 'metadefender_scan_options';
export const ARCHIVE_PASSWORD_SESSION_KEY = 'metadefender_archive_password';
export const SELECTED_WORKFLOW_STORAGE_KEY = 'metadefender_selected_workflow';
export const SELECTED_SCAN_TYPE_STORAGE_KEY = 'metadefender_selected_scan_type';
